import { api } from "@/lib/axios";
import type {
  ApiResponse,
  CompanyApiKeyListItem,
  CompanyApiKeyListResult,
  CompanyApiKeySecret,
  CreateCompanyApiKeyRequest,
  UpdateCompanyApiKeyRequest,
} from "../types/companyApiKey.types";

export const listCompanyApiKeys = async (
  companyGuid: string,
): Promise<CompanyApiKeyListResult> => {
  const { data } = await api.get<ApiResponse<CompanyApiKeyListResult>>(
    "/api/company-api-keys",
    { params: { companyGuid } },
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

/** 평문 조회 — 수정 다이얼로그를 열 때만 호출한다. */
export const revealCompanyApiKey = async (
  idx: number,
): Promise<CompanyApiKeySecret> => {
  const { data } = await api.get<ApiResponse<CompanyApiKeySecret>>(
    `/api/company-api-keys/${idx}/reveal`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const createCompanyApiKey = async (
  req: CreateCompanyApiKeyRequest,
): Promise<CompanyApiKeyListItem> => {
  const { data } = await api.post<ApiResponse<CompanyApiKeyListItem>>(
    "/api/company-api-keys",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const updateCompanyApiKey = async (
  idx: number,
  req: UpdateCompanyApiKeyRequest,
): Promise<CompanyApiKeyListItem> => {
  const { data } = await api.post<ApiResponse<CompanyApiKeyListItem>>(
    `/api/company-api-keys/${idx}`,
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const deleteCompanyApiKey = async (idx: number): Promise<void> => {
  const { data } = await api.post<ApiResponse<boolean>>(
    `/api/company-api-keys/${idx}/delete`,
    {},
  );
  if (data.code !== 200) throw new Error(data.message);
};
